// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import StickyCtaController from "./sticky_cta_controller"
application.register("sticky-cta", StickyCtaController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ProductGalleryController from "./product_gallery_controller"
application.register("product-gallery", ProductGalleryController)

import ProductTabsController from "./product_tabs_controller"
application.register("product-tabs", ProductTabsController)

import StripeCheckoutController from "./stripe_checkout_controller"
application.register("stripe-checkout", StripeCheckoutController)

import ApiKeyController from "./api_key_controller"
application.register("api-key", ApiKeyController)
